import { styled } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';

import { customPalette } from '../../../styles/theme';

interface LoaderContainerProps {
  isFullScreen: boolean;
}

export const LoaderContainer = styled('div')<LoaderContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.isFullScreen ? '100vh' : 'auto')};
`;

export const StyledCircularProgress = styled(CircularProgress)<{
  size?: number;
}>`
  color: ${customPalette.positive['600']};
  width: ${(props) => (props.size ? `${props.size}px` : '40px')};
  height: ${(props) => (props.size ? `${props.size}px` : '40px')};
`;
